import {UserConstants} from "../actions/user";

const handlers = {
  [UserConstants.LOGIN_REQUEST]: (_state: AuthenticationState, _action: AuthenticationAction): AuthenticationState => ({
    loggingIn: true,
    errorMessage: "",
  }),
  [UserConstants.LOGIN_SUCCESS]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    loggingIn: false,
    loggedIn: true,
    authChecked: true,
    user: action.user,
  }),
  [UserConstants.LOGIN_FAILURE]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    loggingIn: false,
    loggedIn: false,
    errorMessage: action.error,
    errorAction: action.errorAction,
  }),
  [UserConstants.LOGOUT_SUCCESS]: (_state: AuthenticationState, _action: AuthenticationAction): AuthenticationState => ({
    loggingIn: false,
    loggedIn: false,
    authChecked: true,
    user: null,
  }),
  [UserConstants.LOGOUT_FAILURE]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    loggingIn: false,
    loggedIn: false,
    errorMessage: action.error,
    user: null
  }),
  [UserConstants.SIGNUP_REQUEST]: (_state: AuthenticationState, _action: AuthenticationAction): AuthenticationState => ({
    signingUp: true,
    errorMessage: "",
  }),
  [UserConstants.SIGNUP_SUCCESS]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    signingUp: false,
    loggedIn: true,
    // Signup auto-logs-in, so auth IS resolved here — same as LOGIN_SUCCESS.
    // Without this, protected routes kept waiting on authChecked and a brand
    // new user landed on a spinner instead of the dashboard.
    authChecked: true,
    user: action.user,
  }),
  [UserConstants.SIGNUP_FAILURE]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    signingUp: false,
    loggedIn: false,
    errorMessage: action.error,
    errorAction: action.errorAction,
  }),
  // The account exists but can't sign in until the emailed code is entered —
  // not an error, and auth is resolved: the visitor is known to be logged out.
  [UserConstants.SIGNUP_CONFIRMATION_REQUIRED]: (_state: AuthenticationState): AuthenticationState => ({
    signingUp: false,
    loggedIn: false,
    authChecked: true,
  }),
  [UserConstants.CLEAR_AUTH_ERROR]: (state: AuthenticationState): AuthenticationState => ({
    ...state,
    errorMessage: "",
    errorAction: undefined,
  }),
  [UserConstants.FORGOT_PASSWORD_REQUEST]: (_state: AuthenticationState): AuthenticationState => ({
    requestingReset: true,
    errorMessage: "",
  }),
  [UserConstants.FORGOT_PASSWORD_SUCCESS]: (_state: AuthenticationState): AuthenticationState => ({
    requestingReset: false,
    resetRequested: true,
  }),
  [UserConstants.FORGOT_PASSWORD_FAILURE]: (_state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    requestingReset: false,
    errorMessage: action.error,
  }),
  [UserConstants.RESET_PASSWORD_REQUEST]: (state: AuthenticationState): AuthenticationState => ({
    ...state,
    resettingPassword: true,
    errorMessage: "",
  }),
  [UserConstants.RESET_PASSWORD_SUCCESS]: (state: AuthenticationState): AuthenticationState => ({
    ...state,
    resettingPassword: false,
    passwordReset: true,
  }),
  [UserConstants.RESET_PASSWORD_FAILURE]: (state: AuthenticationState, action: AuthenticationAction): AuthenticationState => ({
    ...state,
    resettingPassword: false,
    errorMessage: action.error,
  }),
};

export function authentication (state: AuthenticationState = {authChecked: false}, action: AuthenticationAction): AuthenticationState {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (handlers[action.type]) {
    return handlers[action.type].call(null, state, action);
  }
  return state;
}
